import { apiRequest } from "../../../api/apiRequest";
import { DELETE_NOTICE, GET_NOTICE_LIST, POST_CREATE_NOTICE, PUT_EDIT_NOTICE } from "../../../utils/api";
import { CREATE_NOTICE_FAILURE, CREATE_NOTICE_SUCCESS, DELETE_NOTICE_FAILURE, DELETE_NOTICE_SUCCESS, EDIT_NOTICE_FAILURE, EDIT_NOTICE_SUCCESS, GET_NOTICE_LIST_FAILURE, GET_NOTICE_LIST_SUCCESS } from "./notice.actionTypes";

export const createNotice = (payLoad) => async (dispatch) => {
  const formData = new FormData();

  formData.append("classes", JSON.stringify(payLoad.classes));
  formData.append("description", payLoad.description);
  formData.append("title", payLoad.title);
  formData.append("event_date", payLoad.event_date);

  if (payLoad.image !== null) {
    formData.append("image", payLoad.image);
  }

  const result = await apiRequest("post", POST_CREATE_NOTICE, formData);

  if (result.success) {
    dispatch({
      type: CREATE_NOTICE_SUCCESS,
      payload: result.data,
    });
    return { success: true };
  } else {
    dispatch({
      type: CREATE_NOTICE_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const noticeList = () => async (dispatch) => {
  const result = await apiRequest("get", GET_NOTICE_LIST);

  if (result.success) {
    dispatch({
      type: GET_NOTICE_LIST_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: GET_NOTICE_LIST_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const updateNotice = (payLoad) => async (dispatch) => {
  const formData = new FormData();

  formData.append("classes", JSON.stringify(payLoad.classes));
  formData.append("description", payLoad.description);
  formData.append("title", payLoad.title);
  formData.append("event_date", payLoad.event_date);

  if (payLoad.image !== null) {
    formData.append("image", payLoad.image);
  }

  const result = await apiRequest("put", `${PUT_EDIT_NOTICE}/${payLoad?.id}`, formData);

  if (result.success) {
    dispatch({
      type: EDIT_NOTICE_SUCCESS,
      payload: result.data,
    });
    return { success: true };
  } else {
    dispatch({
      type: EDIT_NOTICE_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const deleteNotice = (id) => async (dispatch) => {

  const result = await apiRequest("delete", `${DELETE_NOTICE}/${id}`,);

  if (result.success) {
    dispatch({
      type: DELETE_NOTICE_SUCCESS,
      payload: result.data,
    });
    return { success: true };
  } else {
    dispatch({
      type: DELETE_NOTICE_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

